import PropTypes from 'prop-types';
import styled from 'styled-components';

import SEO from '../components/seo';

const StyledSection = styled.section`
  & > div {
    padding-top: ${({ theme }) => theme.layout().padding4}px;
    margin-bottom: ${({ theme }) => theme.layout().margin2}px;
  }
`;

const StylediFrame = styled.iframe`
  width: 100%;
  height: 1800px;
  border: 0;
  border-radius: ${({ theme }) => theme.border().radius2}px;
  box-shadow: ${({ theme }) => theme.dropShadow.normal};
  overflow: hidden;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }
`;

const IndividualGoogleFormEmbedPage = ({
  pageContext: { title, googleFormEmbedId },
}) => (
  <>
    <SEO title={`SG Code Campus | ${title}`} />
    <StyledSection>
      <div>
        <StylediFrame
          title={title}
          src={`https://docs.google.com/forms/d/e/${googleFormEmbedId}/viewform`}
        >
          Loading…
        </StylediFrame>
      </div>
    </StyledSection>
  </>
);

IndividualGoogleFormEmbedPage.propTypes = {
  pageContext: PropTypes.shape({
    title: PropTypes.string.isRequired,
    googleFormId: PropTypes.string.isRequired,
    googleFormEmbedId: PropTypes.string.isRequired,
  }).isRequired,
};

export default IndividualGoogleFormEmbedPage;
